import { fg } from '@atlassian/jira-feature-gating';

const TimelineHarmonisationM3RelayProvider = {
	get(): boolean {
		return fg('timeline_harmonisation_m3_targeting');
	},
};

export default TimelineHarmonisationM3RelayProvider;
